<template>
  <div class="offer-container">
    <v-dialog v-model="confirm" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Success! </v-card-title>
        <v-card-text
          >Your buy was successful. Please check your email for addition
          information.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirm = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="results-wrapper">
      <div class="form-flex">
        <div class="results-header-container">
          <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
          <div class="results-header">
            <h3>Energy Sources</h3>
          </div>

          <div class="match-header">
            List of my requests &middot;<span class="match-span">
              {{ this.requests.length }} requests</span
            >
          </div>
          <div class="table-wrapper thead">
            <thead>
              <tr>
                <th class="resource-id">No.</th>
                <th class="resource-name">Name</th>
                <th>Volume</th>
                <th>Price</th>
                <th class="resource-action">Action</th>
              </tr>
            </thead>
          </div>
          <div class="table-wrapper table-margin">
            <tbody
              :class="{ active: index == currentRequestIndex }"
              v-for="(request, index) in requests"
              :key="index"
              @click="setActiveRequest(request, index)"
            >
              <tr v-if="request.status === 1">
                <td class="resource-id">{{ request.id }}</td>
                <td class="resource-name">{{ request.locationCode }}</td>
                <td>{{ request.volumeSign === "-" ? "-" + request.volume : request.volume }}</td>
                <td>{{ request.price }}</td>
                <td class="resource-action">
                  <input
                    type="checkbox"
                    v-model="selectedRequestIDs"
                    :value="{ id: request.id }"
                    @change="selectRequests"
                  />
                </td>
              </tr>
            </tbody>
          </div>

          <!-- <p>List of SelectedRequests: {{ selectedRequestIDs }}</p> -->

          <div class="match-header">
            List of matched offers &middot;<span class="match-span">
              {{ this.matchings.length }} matched offers</span
            >
          </div>
          <div class="table-wrapper thead">
            <thead>
              <tr>
                <th class="resource-id">No.</th>
                <th class="resource-name">Name</th>
                <th>Volume</th>
                <th>Price</th>
                <th class="resource-action">Action</th>
              </tr>
            </thead>
          </div>
          <div class="table-wrapper t-bottom" id="offersTable">
            <tbody>
              <tr
                :class="{ active: index == currentMatchingIndex }"
                v-for="(matching, index) in matchings"
                :key="index"
                @click="setActiveRequest(matching, index)"
              >
                <td class="resource-id" v-if="matching.status === 1">
                  {{ matching.id }}
                </td>
                <td class="resource-name" v-if="matching.status === 1">
                  {{ matching.locationCode }}
                </td>
                <td v-if="matching.status === 1">{{ matching.volumeSign === "-" ? "-" + matching.volume : matching.volume }}</td>
                <td v-if="matching.status === 1">{{ matching.price }}</td>
                <td v-if="matching.status === 1" class="resource-action">
                  <input
                    type="checkbox"
                    name="chkRequest"
                    class="checkedOffer"
                    @change="() => selectOffer(matching)"
                  />
                </td>
              </tr>
            </tbody>
          </div>
        </div>
      </div>
    </div>
    <div class="load-wrapper">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <div class="bottom-button-wrapper">
      <v-btn
        depressed
        tile
        color="#58c26d"
        class="match-button2"
        v-on:click="offerRequest"
      >
        Buy
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import RequestDataService from "../../services/RequestDataService";

import OfferDataService from "../../services/OfferDataService";

export default {
  name: "matching-list",

  props: ["currentMatching", "currentIndex", "allMatchings"],

  data() {
    return {
      requests: [],
      totalRequest: null,
      currentRequest: null,
      currentRequestIndex: -1,

      offers: [],
      totalOffer: null,
      currentOffer: null,
      currentOfferIndex: -1,

      matchings: [],
      totalMatching: null,
      currentMatching: null,
      currentMatchingIndex: -1,

      myRequests: [],
      selectedRequestIDs: [],
      selectedRequests: [],

      headers: [
        {
          text: "Name",
          align: "start",
          value: "locationCode",
        },
        { text: "Volume", value: "volume" },
        { text: "Price", value: "price" },
        { text: "", value: "id", sortable: false },
      ],

      myOffers: [
        {
          locationCode: "Offer1",
          volume: 30,
          price: 50,
          id: 1,
        },
        {
          locationCode: "Offer2",
          volume: 40,
          price: 70,
          id: 2,
        },
      ],

      bread: [
        {
          text: "Trading",
          disabled: false,
          // href: "/dashboardAdmin",
        },
        {
          text: "Matching",
          disabled: false,
        },
      ],

      confirm: false,
      matchedRequests: [],

      requestCode: "BUCEZ00220200801",

      filters: [
        {
          type: "LOCATION",
          values: ["002"],
        },
        {
          type: "DAY_TYPE",
          values: ["weekends"],
        },
        /* 
        {  
          "type" : "DATE",
          "values" : ["2021-09-01", "2021-12-31"]
        },
        {  
          "type" : "TIME",
          "values" : ["18:00:00", "22:00:00"]
        } 
        */
      ],

      cities: [],
      postcodes: [],
      countries: [],
      matchedOffers: [],

      columns: [],
      loading: false,
    };
  },

  methods: {
    selectOffer(offer) {
      if (this.matchedOffers.indexOf(offer.offerCode) < 0) {
        this.matchedOffers.push(offer.offerCode);
      } else {
        this.matchedOffers.splice(
          this.matchedOffers.indexOf(offer.offerCode),
          1
        );
      }
    },
    async offerRequest() {
      let payload = {
        offerCodeList: this.matchedOffers,
        requestCodeList: [],
      };
      for (let r of this.selectedRequests) {
        payload.requestCodeList.push(r.requestCode);
      }
      console.log("PAYYYY", payload)
      await this.Apps.offerRequest();
      await OfferDataService.buy(payload)
        .then((response) => {
          console.log("The buy was successfull!!!!!!!! " + response);
          this.confirm = true;
        })
        .catch((e) => {
          console.log("There was an error with the purchase", e);
        });
    },

    setActiveRequest(request, index) {
      this.currentRequest = request;
      this.currentRequestIndex = index;
      //this.filterOffers();
    },

    setActiveOffer(offer, index) {
      this.currentOffer = offer;
      this.currentOfferIndex = index;
    },

    setActiveMatching(matching, index) {
      this.currentMatching = matching;
      this.currentMatchingIndex = index;
    },

    retrieveRequests() {
      if (
        this.$store.state.auth.user.roles == "ROLE_ADMIN" &&
        this.$store.state.auth.user.countryCode == "BE"
      ) {
        RequestDataService.getAll()
          .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      }
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN" || "ROLE_TSO") {
        RequestDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      } else {
        RequestDataService.findByCompanyCode(
          this.$store.state.auth.user.companyCode
        )
          .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      }
    },

    filterOffers() {
      console.log(
        "CHECK... List of selected requests' ID : " + this.selectedRequestIDs
      );
      //this.selectRequests();
      OfferDataService.getAll()
        .then((response) => {
          this.offers = response.data;
          /* console.log("AND... first offer location: ", this.offers[0].locationCode);
          console.log("AND... list of requests: ", this.selectedRequests);
          console.log("AND... first request location: ", this.selectedRequests[0].locationCode); */
          this.matchings = [];
          for (var i = 0; i < this.selectedRequests.length; i++) {
            console.log("iiiiiii", this.selectedRequests[i], this.offers)
            this.matchings = this.matchings.concat(
              this.offers.filter(
                (offer) =>
                  offer.locationName == this.selectedRequests[i].locationCode &&
                  // offer.gridNode == this.selectedRequests[i].gridNode &&
                  // Number(offer.volume) <= Number(this.selectedRequests[i].volume) &&
                  offer.dayType == this.selectedRequests[i].dayType &&
                  (offer.dateFrom == this.selectedRequests[i].dateFrom ||
                    this.toDate(offer.dateFrom) <=
                      this.toDate(this.selectedRequests[i].dateFrom)) &&
                  (offer.dateTo == this.selectedRequests[i].dateTo ||
                    this.toDate(offer.dateTo) >=
                      this.toDate(this.selectedRequests[i].dateFrom)) &&
                  (offer.timeFrom == this.selectedRequests[i].timeFrom ||
                    this.toTime(offer.timeFrom) <=
                      this.toTime(this.selectedRequests[i].timeFrom)) &&
                  (offer.timeTo == this.selectedRequests[i].timeTo ||
                    this.toTime(offer.timeTo) >=
                      this.toTime(this.selectedRequests[i].timeTo))
              )
            );
            //console.log("THEN... results after do matching for the request ", i," are: ", this.matchings);
          }

          /* for (var i = 0; i < this.matchings.length; i++) { 
            console.log("HERE... load matching id: " + this.matchings[i].id);
          } */
          console.log("MMAMAMAMAFADFASFSADFASD", this.matchings)
          this.loading = false;
        })
        .catch((e) => {
          console.log("HERE... load offers error: " + e);
        });
    },

    toDate(dateStr) {
      console.log("CHECK... dateStr: ", dateStr);
      var dateParts = dateStr.split("-");
      console.log("THEN... date: ", dateParts[2], dateParts[1], dateParts[0]);
      return new Date(dateParts[2], dateParts[1], dateParts[0]);
    },

    toTime(timeStr) {
      console.log("CHECK... timeStr: ", timeStr);
      console.log(
        "THEN... Time: ",
        moment(timeStr, "HH:mm:ss").format("HH:mm:ss")
      );
      return moment(timeStr).format("HH:mm:ss");
    },

    selectFewerProps(showMyRequest) {
      const { id, locationCode, volume, price } = showMyRequest;
      return { id, locationCode, volume, price };
    },

    selectRequests() {
      this.loading = true;
      console.log("PAPPAPAPA", this.selectedRequestIDs)
      this.selectedRequests = this.requests.filter((request) => {
        return this.selectedRequestIDs.some((selectedRequestID) => {
          return selectedRequestID.id === request.id;
        });
      });
      this.filterOffers();
    },

    goToBuy() {
      this.$emit("goToBuy");
    },

    checkOffers() {
      console.log("CHECK get offers...", this.offers);
      var totalOffer = 0;
      for (var i = 0; i < this.offers.length; i++) {
        totalOffer = totalOffer + this.offers[i].volume;
      }
      console.log("HERE get total offer...", totalOffer);
      //this.$refs.total_offers.value = totalOffer + " KWh";
      this.totalOffer = totalOffer + " KWh";
      console.log("HERE show total offer...", this.totalOffer);
    },
  },

  updated() {
    // Fired every second, should always be true
    this.checkOffers();
    this.selectedRequests;
  },

  computed: {},

  created() {},

  mounted: function () {
    for (let m of this.allMatchings) {
      this.matchedRequests.push({
        name: "Matched",
        volume: 30,
        price: 50,
        id: m.id,
      });
    }
    this.$store.state.auth.user;
    this.retrieveRequests();
    this.filterOffers();
    this.$nextTick(function () {
      // this.matchingRequests();
      // this.retrieveOffers();
      // console.log("HERE... all requests will be displayed: " + this.requests);
      // console.log(
      //   "HERE... all matchings will be displayed: " +
      //     JSON.stringify(this.allMatchings)
      // );
    });
    //this.getAllOffers(this.requestCode);
    //this.getCandidatesOffers(this.requestCode, this.filters);
    //this.retrieveAssets();
    //this.getColumns();

    /* 
    this.$nextTick(function () {
      
    }); 
    */
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.offer-container {
  min-height: calc(100vh - 50px);
  max-height: calc(100vh - 50px);
  background: #f5fcff;
  width: 410px;
  padding: 20px 30px;
  position: relative;
  overflow-y: auto;
}

.offer-inner-container {
  padding: 40px;
}

.offer-table-wrapper {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
}

.top-offer-table-bar {
  background: #f9fafe;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3fb;
}

.offer-search-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
  max-width: 300px;
}

.offer-input {
  display: inline-block;
  font-size: 0.9rem;
  color: $black;
  line-height: 1.3;
  padding: 0.6em 0.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 10px 0 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.1em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.offer-input:focus,
.offer-search-button:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 10px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.table-wrapper {
  max-height: 120px;
  overflow-y: scroll;
  // -webkit-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  // -moz-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  // box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
}

.table-wrapper thead {
  width: 100%;
  display: block;
  border-bottom: 1px solid #f4f7fa;
  cursor: pointer;
}

.table-wrapper tbody,
.table-wrapper tr {
  width: 100%;
  display: block;
  border-bottom: 1px solid #f4f7fa;
  cursor: pointer;
}

.table-wrapper tr:hover {
  background: #f4f7fa;
}

.table-wrapper td {
  padding: 10px;
  color: #4a4a4a;
  font-size: 14px;
  display: inline-block;
  width: 20%;
}

.table-wrapper th {
  background: #253858;
  padding: 10px;
  color: #f7f7f7;
  font-size: 14px;
  display: inline-block;
  width: 20%;
}

.table-wrapper thead {
  background: #f7f7f7;
}

.resource-id {
  width: 10% !important;
}

.resource-name {
  width: 30% !important;
}

.resource-action {
  text-align: center;
}

.offer-table {
  background: #fff;
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

.offer-table th {
  position: sticky;
  top: 0;
  color: #4a4a4a;
  font-size: 16px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 12px 10px;
  border-spacing: 0;
  margin: 0;
  text-align: left;
}

.offer-table tr {
  cursor: pointer;
}

.offer-table tr:hover {
  background: hsla(132, 46, 55, 0.2);
}

.active {
  background: hsla(132, 46, 55, 0.5);
}

.active:hover {
  background: hsla(132, 46, 55, 0.5) !important;
}

.table-button {
  background: none;
  border: none;
  padding: 0 5px;
  color: #007bff;
}

.table-button:hover {
  text-decoration: underline;
  color: #007bff;
}

.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.table-info-wrapper {
  margin-bottom: 10px;
  margin-top: 20px;
  background-color: #fff;
  padding: 20px 20px 20px 20px;
  border-radius: 10px;
  overflow: hidden;
  -webkit-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
}
.popup-top {
  display: flex;
  justify-content: space-between;
}
.popup-flex {
  display: flex;
  justify-content: space-between;
}

.load-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}

.table-popup-left,
.table-popup-top-left {
  width: 60%;
  position: relative;
}
.table-popup-right,
.table-popup-top-right {
  width: 40%;
  position: relative;
}
.table-tag {
  padding: 5px 20px;
  background-color: #253858;
  color: #fff;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  margin-right: -20px;
}
.popup-title {
  font-weight: 700;
  font-size: 1.3rem;
  color: #253858;
}
.popup-label {
  color: #aeacad;
  font-size: 0.9rem;
  margin-top: 10px;
}
.popup-info {
  font-size: 0.9rem;
  color: #253858;
}

.fa-clock,
.fa-map-marker-alt {
  color: #b4b2b2;
}

.table-icon .fa-clock {
  margin-left: 10px;
}

.popup-price {
  font-size: 1rem;
  font-weight: 700;
  color: #253858;
}
.table-button {
  background-color: #58c26d;
  color: #fff;
  border: none;
  margin-top: 20px;
  padding: 8px 40px;
  border-radius: 5px;
  cursor: pointer;
}

.table-button:hover {
  background-color: hsla(132, 46, 55, 0.8);
  color: #fff;
  text-decoration: none;
}
.table-icon {
  font-size: 0.8em;
}
.table-middle {
  padding-bottom: 5px;
  border-bottom: 1px solid #253858;
}

.matching-button-wrapper {
  display: flex;
  align-items: center;
  margin: 20px 0 30px 0;
}

.bottom-button-wrapper {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-margin {
  margin-bottom: 30px;
}

.match-header {
  font-size: 20px;
  color: #3f516d;
  margin-bottom: 10px;
}

.match-span {
  font-size: 14px;
  color: #a3a3a4;
}
</style>
